var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96545 10.4502C3.62247 10.7896 3.38589 11.2198 3.28414 11.6891L3.00574 12.9732C2.96701 13.1518 3.1293 13.3096 3.30908 13.268L4.46991 13C4.92733 12.8944 5.34577 12.6642 5.6779 12.3356L10.3605 7.41822C10.5511 7.22964 10.5578 6.92601 10.3758 6.72937L9.32689 5.59648C9.13322 5.3873 8.80238 5.38014 8.59965 5.58075L3.96545 10.4502ZM12.8232 4.98263C13.0131 4.79395 13.0195 4.49084 12.8377 4.29448L11.7889 3.16166C11.5949 2.95219 11.2635 2.94534 11.0609 3.14662L10.0426 4.15835C9.85263 4.34703 9.84624 4.65014 10.028 4.8465L11.0768 5.97933C11.2708 6.1888 11.6022 6.19564 11.8048 5.99437L12.8232 4.98263Z",
    fill: "#FC4C02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.bc0a0398c777718f30a7f0d64090fa6e.svg";
export { ForwardRef as ReactComponent };